<ng-container>
  <div class="preloader" *ngIf="userVM.loading">Loading...</div>
  <table class="channel-permissions" *ngIf="!userVM.loading">
    <thead>
      <tr>
        <th>Channel</th>
        <th *ngIf="userVM.editableUser.managedTenantIds.length > 1">Tenant</th>
        <th
          class="button"
          (click)="userVM.togglePermissionOnAllChannels('view')"
        >
          View Scheduler
        </th>
        <th
          class="button"
          (click)="userVM.togglePermissionOnAllChannels('editSchedule')"
        >
          Edit Schedule
        </th>
        <th
          *ngIf="userVM.currentUser.isSuperUser"
          class="button"
          (click)="userVM.togglePermissionOnAllChannels('editSettings')"
        >
          Edit Settings
        </th>
        <th
          class="button"
          (click)="
            userVM.togglePermissionOnAllChannels('activateDeactivateChannel')
          "
        >
          Activate/Deactivate
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        class="row"
        *ngFor="let channelPermissionsVM of userVM.channelPermissionsVMs"
      >
        <td>{{ channelPermissionsVM.channelName }}</td>
        <td *ngIf="userVM.editableUser.managedTenantIds.length > 1">
          {{ channelPermissionsVM.tenantName }}
        </td>
        <td>
          <evrideo-checkbox
            [(active)]="channelPermissionsVM.view"
            (checked)="
              userVM.setChannelPermission(
                channelPermissionsVM.channelId,
                'view',
                channelPermissionsVM.view
              )
            "
          ></evrideo-checkbox>
        </td>
        <td>
          <evrideo-checkbox
            [(active)]="channelPermissionsVM.editSchedule"
            (checked)="
              userVM.setChannelPermission(
                channelPermissionsVM.channelId,
                'editSchedule',
                channelPermissionsVM.editSchedule
              )
            "
          ></evrideo-checkbox>
        </td>
        <td *ngIf="userVM.currentUser.isSuperUser">
          <evrideo-checkbox
            [(active)]="channelPermissionsVM.editSettings"
            (checked)="
              userVM.setChannelPermission(
                channelPermissionsVM.channelId,
                'editSettings',
                channelPermissionsVM.editSettings
              )
            "
          ></evrideo-checkbox>
        </td>
        <td>
          <evrideo-checkbox
            [(active)]="channelPermissionsVM.activateDeactivateChannel"
            (checked)="
              userVM.setChannelPermission(
                channelPermissionsVM.channelId,
                'activateDeactivateChannel',
                channelPermissionsVM.activateDeactivateChannel
              )
            "
          ></evrideo-checkbox>
        </td>
      </tr>
    </tbody>
  </table>
</ng-container>
